import React, { useState } from "react";
import { BsArrowUpRight } from "react-icons/bs";
import { GoArrowSmallRight } from "react-icons/go";
// import image from '../../assets/images/portfolio-01.jpg';
import AOS from "aos";
import "aos/dist/aos.css";
import { motion } from "framer-motion";

import DetailtsModal from "../DetailtsModal/DetailtsModal";
const MyWorks = ({ data, handleDetailsProject }) => {
  const [showModal, setShowModal] = useState(false);
  const {
    images,
    name,
    liveLink,
    category,
    serverCode,
    clientCode,
    websitePerpas,
  } = data;
  AOS.init({
    delay: 0, // values from 0 to 3000, with step 50ms
    duration: 500,
  });
  return (
    <>
      <div
        data-aos="zoom-in"
        className=" bg-own-primary border-[1px] border-opacity-10 border-own-border-color card p-6 rounded-md flex flex-col justify-between"
      >
        <div>
          <img
            className="transform projectImage rounded-md shadow-sm"
            src={images[0]}
            alt=""
          />
        </div>
        <div className="text-left">
          <div className="flex justify-between items-center my-2">
            <span className="text-sm  text-own-secondary flex items-center justify-center">
              <span className="text-own-gray-white mr-2 font-medium">
                Category
              </span>
              {category}
            </span>
          </div>
          <h3 className="text-2xl title   text-own-gray-white font-medium ">
            {name} <BsArrowUpRight className="inline upAro" />{" "}
          </h3>
          <div className=" flex mt-4   flex-col  text-xl font-bold text-sweet_red">
            <label
              onClick={() => handleDetailsProject(data)}
              for="my-modal-6"
              className="btn-animated-solid text-center mb-5 "
            >
              Details
            </label>
            <a
              href={liveLink}
              className="btn-animated-bordered text-center "
              target="_blank"
            >
              Live View
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default MyWorks;
